import { SharedNodeTitles } from "@p0security/shared/assessment/constants";
import { ResourceNode } from "@p0security/shared/types/assessment/data/index";
import { ExportColumnType } from "components/Assessment/utils/export";
import { GraphTooltip } from "components/GraphTooltip";

import { Resource } from "../../cells/Resource";
import { ShowHideTerm } from "../../cells/ShowHide";
import { genericExport } from "../../export";
import { stringSorter } from "../../sort";
import { AssessmentColumnProps } from "../columns";
import { resourceLabels } from "./labels";

export const resourceColumns = (
  props: AssessmentColumnProps
): ExportColumnType<ResourceNode>[] => [
  {
    key: "resource",
    title: SharedNodeTitles.resource,
    ellipsis: true,
    sorter: (left, right) => stringSorter(left.key, right.key),
    render: (node) => {
      return node && <Resource resource={node} {...props} />;
    },
    export: genericExport((node) => node.key),
    width: 300,
  },
  {
    key: "service",
    title: "Service",
    sorter: (left, right) =>
      stringSorter(left.data.service ?? "", right.data.service ?? ""),
    render: (node) => {
      const value = resourceLabels(node.data, props.provider).service;
      return (
        <GraphTooltip
          title={
            <>
              {value}
              <ShowHideTerm
                term={`resource=service:"${node.data.service}"`}
                name="services"
                {...props}
              />
            </>
          }
        >
          {value}
        </GraphTooltip>
      );
    },
    width: 200,
  },
  {
    key: "type",
    title: "Type",
    sorter: (left, right) =>
      stringSorter(left.data.type ?? "", right.data.type ?? ""),
    render: (node) => {
      const value = resourceLabels(node.data, props.provider).type;
      return (
        <GraphTooltip
          title={
            <>
              {value}
              <ShowHideTerm
                term={`resource=type:"${node.data.type}"`}
                name="resource types"
                {...props}
              />
            </>
          }
        >
          {value}
        </GraphTooltip>
      );
    },
    width: 200,
  },
];
